import { useAuthentication } from '../../../utils/useAuthentication';
import React, { useCallback, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { IconEdit, IconPlus } from '@tabler/icons-react';
import ModalEdit from './modalEdit';
import { useShop } from '../../../hooks/Shop/useShop';
import UITable from '../../utilities/Table';
import { SectionHeader, UIPageHeader } from '../../utilities/Headers';

const ShopBannersView = () => {
  const data = useAuthentication();
  const user = data?.user?.account_data;
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);

  const { onListShopBanners } = useShop();

  const handleModalClose = useCallback(() => {
    setEditMode(false);
    setSelectedBanner(null);
    setForceUpdate(true);
  }, []);

  const prepareValues = (banners) =>
    banners?.map((banner) => {
      return {
        banner: banner,
        nameEl: (
          <Box>
            <Typography fontFamily={'Oxygen'} fontWeight={'700'} fontSize={'14px'}>
              {banner?.name}
            </Typography>
          </Box>
        ),
        actionsEl: (
          <Box
            onClick={() => {
              setSelectedBanner(banner);
              setEditMode(true);
            }}
          >
            <IconEdit cursor={'pointer'} />
          </Box>
        )
      };
    });

  return (
    <Box className="products-view" w={'100%'} h={'100%'} overflow={'auto'}>
      <Box
        position={'fixed'}
        display={'flex'}
        right={10}
        bottom={10}
        bgcolor={'#2c3e50'}
        p={'10px'}
        borderRadius={'100%'}
        w={'50px'}
        h={'50px'}
        color={'white'}
        justifyContent={'center'}
        alignItems={'center'}
        cursor={'pointer'}
        onClick={() => {
          setSelectedBanner(null);
          setEditMode(true);
        }}
      >
        <IconPlus stroke={3} size="2rem" />
      </Box>

      <ModalEdit user={user} modalOpen={editMode} handleModalClose={handleModalClose} banner={selectedBanner} setEditMode={setEditMode} />

      <UIPageHeader
        title={'Banners'}
        subtitle={
          "Gestisci qui i tuoi banners. In questa lista appariranno tutti i banner che hai creato. Clicca sull'icona dell'editor per modificarli."
        }
      />

      <SectionHeader title={'Ricerca banner'} subtitle={`E' possibile cercare per nome.`} />
      <UITable
        columns={[
          {
            name: 'Nome banner',
            value: 'nameEl',
            size: 400
          },
          {
            name: 'Azioni',
            value: 'actionsEl',
            size: 100
          }
        ]}
        prepareValues={prepareValues}
        enableSearch={true}
        enableCustomFilters={false}
        infiniteScrollEndMessage={'Non ci sono altri articoli da mostrare'}
        infiniteScrollFunction={onListShopBanners}
        tableHeight={'calc(100vh - 400px)'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
      />
    </Box>
  );
};
export default ShopBannersView;
